import { render, staticRenderFns } from "./RegistSubRep.vue?vue&type=template&id=5120a884&scoped=true&"
import script from "./RegistSubRep.vue?vue&type=script&lang=js&"
export * from "./RegistSubRep.vue?vue&type=script&lang=js&"
import style0 from "./RegistSubRep.vue?vue&type=style&index=0&id=5120a884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120a884",
  null
  
)

export default component.exports